<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousClientView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center style="margin-left: 0.5rem !important"
            >Add Client Department</b-navbar-brand
          >
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <md-layout md-gutter>
              <md-layout md-flex="40">
                <label for="clientType">Client</label>
                <model-list-select
                  :disabled="permissionStatus"
                  :list="clientList"
                  v-model="clientDetails"
                  option-value="clientId"
                  option-text="clientName"
                  placeholder="Select Client"
                ></model-list-select>

                <span class="error" v-if="!clientDetail.clientType">{{
                  clientTypeError
                }}</span>
              </md-layout>
            </md-layout>

            <br /><br />

            <md-layout md-gutter class="justify-content-center">
              <md-layout md-flex="45">
                <label for="clientType">Account Manager</label>
                <!-- <model-list-select
                  :disabled="permissionStatus"
                  :list="userList"
                  v-model="accountManagerList"
                  option-value="value"
                  option-text="text"
                  placeholder="Select"
                ></model-list-select> -->

                <multi-select
                  :options="userList"
                  :selected-options="accountManagerList"
                  placeholder="select"
                  @select="SelectAM"
                >
                </multi-select>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="justify-content-center">
              <md-layout md-flex="45">
                <label for="clientType">Customize Service</label>
                <!-- <model-list-select
                  :disabled="permissionStatus"
                   :list="userList"
                  v-model="clientDetail.clientType"
                  option-value="userId"
                  option-text="employeeName"
                  placeholder="Select"
                ></model-list-select> -->

                <multi-select
                  :options="userList"
                  :selected-options="CsList"
                  placeholder="select"
                  @select="SelectCS"
                >
                </multi-select>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="justify-content-center">
              <md-layout md-flex="45">
                <label for="clientType">Documentary</label>
                <!-- <model-list-select
                  :disabled="permissionStatus"
                  :list="userList"
                  v-model="clientDetail.clientType"
                  option-value="userId"
                  option-text="employeeName"
                  placeholder="Select"
                ></model-list-select> -->

                <multi-select
                  :options="userList"
                  :selected-options="documentaryList"
                  placeholder="select"
                  @select="selectDoc"
                >
                </multi-select>
              </md-layout>
            </md-layout>

            <md-layout md-gutter>
              <md-layout class="justify-content-center mt-3">
                <b-button
                  class="smbutnWidth"
                  variant="primary"
                  :disabled="permissionStatus"
                  @click="addClientDept"
                  id="addButtonLoader"
                  >Save</b-button
                >
                <md-spinner
                  md-indeterminate
                  id="loader"
                  style="display: none"
                ></md-spinner>

                <md-spinner
                  md-indeterminate
                  id="loader"
                  style="display: none"
                ></md-spinner>
              </md-layout>
            </md-layout>
          </b-card-text>
        </b-card>

        <b-card class="formCard" v-if="false">
          <b-card-text>
            <md-layout md-gutter>
              <md-layout md-flex="40">
                <label for="clientType">Client Type</label>
                <model-list-select
                  :disabled="permissionStatus"
                  :list="clientTypeList"
                  v-model="clientDetail.clientType"
                  option-value="clientTypeVal"
                  option-text="clientTypeText"
                  placeholder="Select Type"
                ></model-list-select>

                <span class="error" v-if="!clientDetail.clientType">{{
                  clientTypeError
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="55">
                <md-layout md-flex="100">
                  <label>Client Name</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="clientName"
                    id="clientName"
                    v-model="clientDetail.clientName"
                    :disabled="
                      clientDetail.clientId != '' &&
                      this.$sessionsStorage.get('designation') != 'Admin'
                        ? true
                        : false
                    "
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!clientDetail.clientName">{{
                  clientError
                }}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter style="margin-top: 10px">
              <md-layout md-flex="40">
                <md-layout md-flex="100">
                  <label>Contact Number</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    type="number"
                    min="0"
                    name="phoneKYC"
                    id="phoneKYC"
                    v-model="clientDetail.phoneKYC"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!clientDetail.phoneKYC">{{
                  phoneKYCError
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>Email Address</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="email"
                    id="email"
                    @keyup="isEmailValid"
                    v-model="clientDetail.email"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!clientDetail.email">{{
                  emailError
                }}</span>
                <span class="error" v-if="clientDetail.email">{{
                  errorEmailFormat
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>Alternate Email</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="altMail"
                    id="altMail"
                    v-model="clientDetail.altMail"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="40">
                <md-layout md-flex="100">
                  <label>PAN No.(AAAAA1234A)</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="panNO"
                    id="panNO"
                    v-model="clientDetail.panNO"
                    @keyup="PANErrorValid1()"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!clientDetail.panNO">{{
                  panNOError
                }}</span>
                <span class="error" v-else>{{ PANErrorValid }}</span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>IEC Number</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="clientName"
                    id="clientName"
                    v-model="clientDetail.IEC"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label for="companyType">Type of Company</label>

                  <model-list-select
                    :disabled="permissionStatus"
                    :list="companyTypeList"
                    v-model="clientDetail.companyType"
                    option-value="companyTypeVal"
                    option-text="companyTypeText"
                    placeholder="Select Company Type"
                  ></model-list-select>
                </md-layout>
                <span class="error" v-if="!clientDetail.companyType">{{
                  companyTypeError
                }}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="20">
                <label for="State">State</label>
                <model-list-select
                  :isDisabled="permissionStatus"
                  :list="stateDetail"
                  v-model="clientDetail.state"
                  option-value="stateId"
                  option-text="stateName"
                  placeholder="Select State "
                ></model-list-select>

                <span class="error" v-if="!clientDetail.state">{{
                  stateError
                }}</span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label for="companyType">Company Permitted</label>

                  <model-list-select
                    :disabled="permissionStatus"
                    :list="companyPermitList"
                    v-model="clientDetail.permitted"
                    option-value="permitVal"
                    option-text="permitText"
                    placeholder="Select Permit Type"
                  ></model-list-select>
                </md-layout>
                <span class="error" v-if="!clientDetail.permitted">{{
                  permittedError
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20" class="pl-2">
                <md-layout md-flex="100">
                  <label>TAN No.(AAAA12345A)</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="tanNO"
                    id="tanNO"
                    v-model="clientDetail.tanNO"
                    @keyup="TANErrorValid1()"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!clientDetail.tanNO">{{
                  tanNOError
                }}</span>
                <span class="error" v-else>{{ TANErrorValid }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout
                md-flex="5"
                v-if="clientDetail.permitted != 'GSTUnregistered'"
              >
                <md-layout md-flex="100">
                  <label>Code</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="StateCode"
                    id="StateCode"
                    v-model="clientDetail.stateCode"
                    disabled
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout
                md-flex="20"
                v-if="clientDetail.permitted != 'GSTUnregistered'"
              >
                <md-layout md-flex="100">
                  <label>GSTN No.(AAAAA1234A1Z5)</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="GSTN"
                    id="GSTN"
                    v-model="clientDetail.GSTN"
                    @keyup="GSTNErrorValid1()"
                    :disabled="
                      permissionStatus
                        ? true
                        : clientDetail.state == ''
                        ? true
                        : false
                    "
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!clientDetail.GSTN">{{
                  GSTNError
                }}</span>
                <span class="error" v-else>{{ GSTNErrorValid }}</span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr">
              <md-layout md-flex="100">
                <md-layout md-flex="100">
                  <label>Corporate Address</label>
                  <b-form-textarea
                    :formatter="(value) => value.toUpperCase()"
                    name="corporateAddress"
                    id="corporateAddress"
                    v-model="clientDetail.corporateAddress"
                    :disabled="permissionStatus"
                  ></b-form-textarea>
                </md-layout>
                <span class="error" v-if="!clientDetail.corporateAddress">{{
                  corporateAddressError
                }}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="50" class="pr-2">
                <md-layout md-flex="100">
                  <label>Credit Days</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="creditDays"
                    id="creditDays"
                    v-model="clientDetail.creditDays"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="mt-3">
              <span>Segment :</span>
            </md-layout>
            <md-layout md-gutter>
              <md-layout
                v-for="(segmentNameArray, index) in showSegmentArray"
                :key="index"
                :md-flex="segmentNameArray.flex"
              >
                <md-checkbox
                  v-model="clientDetail.segment[index]"
                  class="md-primary"
                  :md-value="segmentNameArray.value"
                  :name="'segment' + (index + 1)"
                  :id="'segment' + (index + 1)"
                  :disabled="permissionStatus"
                  >{{ segmentNameArray.show }}</md-checkbox
                >
              </md-layout>
            </md-layout>

            <div class="mt-3">
              <md-layout md-gutter>
                <div>
                  <b-button
                    id="show-btn"
                    size="sm"
                    variant="dark"
                    @click="showModal"
                    >Add Client Factory</b-button
                  >
                  <span class="error" v-if="multiFactError != ''">{{
                    this.multiFactError
                  }}</span>
                  <b-modal ref="my-modal" hide-footer title="">
                    <div class="d-block text-center">
                      <h5>Client Factory Details !</h5>
                      <hr />

                      <md-layout md-gutter>
                        <md-layout md-flex="5"></md-layout>

                        <span class="error">{{
                          this.viewAllFactory.length == 0 ? multiFactError : ""
                        }}</span>
                      </md-layout>
                      <md-layout md-gutter>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="90">
                          <md-layout md-flex="100">
                            <label
                              >Factory Title-Location]( e.g : Pridel Pvt
                              Ltd-Delhi)</label
                            >
                            <b-form-input
                              :formatter="capitalizeAll"
                              name="factoryTitle"
                              id="factoryTitle"
                              v-model="factoryModal.factoryTitle"
                              :disabled="permissionStatus"
                            ></b-form-input>
                            <span
                              class="error"
                              v-if="!factoryModal.factoryTitle"
                              >{{ factoryTitleError }}</span
                            >
                          </md-layout>
                        </md-layout>
                      </md-layout>
                      <md-layout md-gutter class="gutr">
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="90">
                          <md-layout md-flex="100">
                            <label>Address</label>
                            <b-form-textarea
                              :formatter="(value) => value.toUpperCase()"
                              name="factoryAddress1"
                              id="factoryAddress1"
                              v-model="factoryModal.factoryAddress1"
                              :disabled="permissionStatus"
                            ></b-form-textarea>
                            <span
                              class="error"
                              v-if="!factoryModal.factoryAddress1"
                              >{{ factoryAddress1Error }}</span
                            >
                          </md-layout>
                        </md-layout>
                      </md-layout>
                      <md-layout md-gutter class="gutr">
                        <div class="mt-2">
                          <b-button
                            :disabled="
                              factoryModal.factoryAddress1 == '' ? true : false
                            "
                            class="pull-left ml-4"
                            size="sm"
                            variant="outline-info"
                            @click="fetchLatLog"
                            >Get Lat/Long</b-button
                          >
                        </div>
                      </md-layout>

                      <md-layout md-gutter class="gutr">
                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="45">
                          <md-layout md-flex="100">
                            <label>Latitude</label>
                            <b-form-input
                              :formatter="capitalizeAll"
                              type="number"
                              min="0"
                              id="latitude"
                              name="latitude"
                              v-model="factoryModal.latitude"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="45">
                          <md-layout md-flex="100">
                            <label>Longitude</label>
                            <b-form-input
                              :formatter="capitalizeAll"
                              type="number"
                              min="0"
                              id="latitude"
                              name="latitude"
                              v-model="factoryModal.longitude"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                      </md-layout>
                      <md-layout md-gutter class="gutr">
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="90">
                          <md-layout md-flex="100">
                            <label>GSTIN No</label>
                            <b-form-input
                              :formatter="capitalizeAll"
                              name="GSTIN1"
                              id="GSTIN1"
                              v-model="factoryModal.GSTIN1"
                              :disabled="permissionStatus"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                      </md-layout>
                    </div>
                    <b-button
                      class="mt-3"
                      block
                      variant="primary"
                      @click="addClient('')"
                      >{{
                        factoryModal.multiFactoryId == "" ? "Add " : "Update "
                      }}
                      Factory
                    </b-button>
                    <b-button
                      class="mt-3"
                      variant="outline-danger"
                      block
                      @click="hideModal"
                      >Close
                    </b-button>
                  </b-modal>
                </div>
              </md-layout>

              <div class="gutr" v-if="viewAllFactory.length > 0">
                <table id="factoryDetails" class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Factory Title</th>
                      <th>Factory Address</th>

                      <th>Factory GSTIN</th>
                      <th>Latitude</th>
                      <th>Longitude</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in viewAllFactory" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td
                        v-if="item.enableEdit == '1'"
                        @click="EditFactory(item)"
                        class="showMoreData"
                      >
                        {{ item.factoryTitle }}
                      </td>
                      <td v-else>{{ item.factoryTitle }}</td>
                      <td>{{ item.factoryAddress1 }}</td>

                      <td>{{ item.GSTIN1 }}</td>
                      <td>{{ item.latitude }}</td>
                      <td>{{ item.longitude }}</td>
                      <td>
                        <md-button
                          class="md-icon-button md-raised md-dense"
                          @click="deleteData(item.multiFactoryId)"
                        >
                          <md-icon>delete_sweep</md-icon>
                        </md-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <h5 class="mt-3" v-if="contactPersonArry.length > 0">
              <b-badge variant="info">Contact Person</b-badge>
            </h5>
            <b-button
              class="mt-3"
              v-else
              id="show-btn"
              size="sm"
              variant="dark"
              @click="AddMoreContactP"
              >Add Contact Person</b-button
            >

            <div class="mt-3" v-if="contactPersonArry.length > 0">
              <table class="table table-bordered table-striped">
                <tbody>
                  <tr>
                    <th>
                      Sr No.<br />
                      <b-button
                        class="mt-2"
                        size="sm"
                        variant="outline-info"
                        @click="AddMoreContactP"
                        >Add More
                        <!-- @click="addQuotationFields" -->
                      </b-button>
                    </th>
                    <th>Name</th>
                    <th>Contact</th>
                    <th>Email</th>
                    <th>Dept</th>
                    <th>Designation</th>
                    <th></th>
                  </tr>
                  <tr v-for="(item, index) in contactPersonArry" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <b-form-input
                        :formatter="capitalizeAll"
                        v-model="item.name"
                      ></b-form-input>
                    </td>

                    <td>
                      <b-form-input
                        :formatter="capitalizeAll"
                        v-model="item.phone"
                      ></b-form-input>
                    </td>
                    <td>
                      <b-form-input
                        :formatter="capitalizeAll"
                        v-model="item.email"
                      ></b-form-input>
                    </td>
                    <td>
                      <b-form-input
                        :formatter="capitalizeAll"
                        v-model="item.dept"
                      ></b-form-input>
                    </td>
                    <td>
                      <b-form-input
                        :formatter="capitalizeAll"
                        v-model="item.deg"
                      ></b-form-input>
                    </td>

                    <td>
                      <b-button
                        variant="outline-danger"
                        @click="removeCp(index)"
                        size="sm"
                        >Remove</b-button
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <md-layout md-gutter class="mt-4">
              <md-layout md-flex="10">
                <b>KYC Done :</b>
              </md-layout>

              <md-layout md-flex="10">
                <md-radio
                  id="isKYC1"
                  name="isKYC1"
                  @change="AddMoreDocs"
                  v-model="clientDetail.isKYC"
                  md-value="Yes"
                  class="md-primary margn-0px"
                  :disabled="permissionStatus"
                  >Yes</md-radio
                >
              </md-layout>

              <md-layout md-flex="10">
                <md-radio
                  id="isKYC2"
                  name="isKYC2"
                  v-model="clientDetail.isKYC"
                  md-value="No"
                  class="md-primary margn-0px"
                  :disabled="permissionStatus"
                  >No</md-radio
                >
              </md-layout>
            </md-layout>
            <div
              class="mt-3"
              v-if="showDocSection.length > 0 || clientDetail.isKYC == 'Yes'"
            >
              <table class="table table-bordered table-striped">
                <tbody>
                  <tr>
                    <th>Sr No.</th>
                    <th>Document Name</th>
                    <th>Upload Document</th>
                    <th>View</th>
                    <th>
                      <b-button
                        class="mt-2"
                        size="sm"
                        variant="outline-info"
                        @click="AddMoreDocs"
                        >Add More
                        <!-- @click="addQuotationFields" -->
                      </b-button>
                    </th>
                  </tr>
                  <tr v-for="(item, index) in showDocSection" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <model-list-select
                        v-model="item.kycDocName"
                        :disabled="permissionStatus"
                        :list="docList"
                        option-value="docV"
                        option-text="docT"
                        placeholder="Select Document"
                      ></model-list-select>
                    </td>

                    <td>
                      <md-input-container style="margin-top: -35px">
                        <md-file
                          @selected="onFileChangeKyc(index, item.kycDocName)"
                          v-model="item.uploadedkycDoc"
                        ></md-file>
                      </md-input-container>
                    </td>

                    <td>
                      <!-- @click="previewPrivateDocs(item.uploadedkycDoc)" -->
                      <a
                        class="showMoreData"
                        v-if="item.uploadedkycDoc != ''"
                        :href="
                          `${docURL}/` +
                          `${
                            item.uploadedkycDoc.includes('CLIENTKYCDOC')
                              ? ''
                              : 'CLIENTKYCDOC/'
                          }` +
                          item.uploadedkycDoc
                        "
                        target="_blank"
                        download
                        ><u>View Document - {{ index + 1 }}</u></a
                      >
                    </td>

                    <td>
                      <b-button
                        variant="outline-danger"
                        @click="removeDoc(index)"
                        size="sm"
                        >Remove</b-button
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <md-layout md-gutter>
              <md-layout md-flex="100">
                <md-layout md-flex="100">
                  <label>Remark </label>
                  <b-form-textarea
                    :formatter="(value) => value.toUpperCase()"
                    name="remarkOtherDocument"
                    id="remarkOtherDocument"
                    v-model="clientDetail.remarkOtherDocument"
                  ></b-form-textarea>
                </md-layout>
              </md-layout>
            </md-layout>

            <md-layout md-gutter v-if="clientDetail.isKYC == 'Yes'">
              <md-layout md-flex="5"></md-layout>
              <span class="error" v-if="clientDetail.panCard == ''">{{
                panCardError
              }}</span>
            </md-layout>

            <md-layout md-gutter v-if="clientDetail.isKYC == 'Yes'">
              <md-layout md-flex="5"></md-layout>

              <span class="error" v-if="clientDetail.aadharCard == ''">{{
                aadharError
              }}</span>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="10">
                <b-button
                  class="smbutnWidth mt-3"
                  variant="primary"
                  :disabled="permissionStatus"
                  @click="addClient('csfds')"
                  id="addButtonLoader"
                  >Save</b-button
                >
                <md-spinner
                  md-indeterminate
                  id="loader"
                  style="display: none"
                ></md-spinner>

                <md-spinner
                  md-indeterminate
                  id="loader"
                  style="display: none"
                ></md-spinner>
              </md-layout>
            </md-layout>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog
      class="HereDialog"
      md-open-from="#custom"
      md-close-to="#custom"
      ref="dialogLocation"
    >
      <md-dialog-content>
        <pickupLocation />
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closeModalLocation"
          >Close</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <md-dialog
      class="HereDialog"
      md-open-from="#custom"
      md-close-to="#custom"
      ref="dialog2"
    >
      <md-dialog-content>
        <div class="box margn-0px">
          <!-- /.box-header -->
          <div class="box-body">
            <md-layout md-gutter class="modal-header-set">
              <md-layout md-flex="40"></md-layout>
              <md-layout md-flex="55">
                <h2 style="margin: 7px">Contract Detail</h2>
              </md-layout>
              <md-layout md-flex="5">
                <md-button
                  class="md-icon-button md-raised md-dense modal-close-btnn"
                  @click="closeModal()"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-layout>
            </md-layout>

            <md-layout md-gutter style="margin-top: 15px">
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>Select Contract Type</label>
                  <model-list-select
                    :isDisabled="permissionStatus"
                    :list="contractListName"
                    v-model="contractDetailModal.contractType"
                    option-value="contractTypeVal"
                    option-text="contractTypeText"
                    placeholder="Select Contract Type "
                  ></model-list-select>
                </md-layout>
                <span class="error" v-if="!contractDetailModal.contractType">{{
                  isContractError
                }}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Validity From Date</label>
                <date-picker
                  :format="selectDateFormat"
                  lang="en"
                  v-model="contractDetailModal.fromValidity"
                  :disabled="permissionStatus"
                  id="Date"
                ></date-picker>
                <span class="error" v-if="!contractDetailModal.fromValidity">{{
                  isFromValidtyError
                }}</span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Validity To Date</label>
                <date-picker
                  :format="selectDateFormat"
                  lang="en"
                  v-model="contractDetailModal.toValidity"
                  :disabled="permissionStatus"
                  id="Date"
                ></date-picker>
                <span class="error" v-if="!contractDetailModal.toValidity">{{
                  isToValidtyError
                }}</span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Monthly fixed rental for each dedicated vehicle</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="monthlyRent"
                    name="monthlyRent"
                    v-model="contractDetailModal.monthlyRent"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!contractDetailModal.monthlyRent">{{
                  isMonthlyRentError
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>Number of dedicated vehicles</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    type="number"
                    min="0"
                    id="noOfTrucks"
                    name="noOfTrucks"
                    v-model="contractDetailModal.noOfTrucks"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>

                <span class="error" v-if="!contractDetailModal.noOfTrucks">{{
                  noOfTrucksError
                }}</span>
              </md-layout>
            </md-layout>

            <md-layout
              md-gutter
              class="gutr"
              v-if="contractDetailModal.contractType == 'fuelType'"
            >
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <md-layout md-flex="100">
                  <label>Mileage</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="milage"
                    name="milage"
                    v-model="contractDetailModal.milage"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!contractDetailModal.milage">{{
                  milageError
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>Diesel Rate</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    type="number"
                    min="0"
                    id="dieselRate"
                    name="dieselRate"
                    v-model="contractDetailModal.dieselRate"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>

                <span class="error" v-if="!contractDetailModal.dieselRate">{{
                  dieselRateError
                }}</span>
              </md-layout>
            </md-layout>

            <md-layout
              md-gutter
              class="gutr"
              v-if="contractDetailModal.contractType == 'freeKMType'"
            >
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>Free Kilometer per vehicle per months</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="allowedKm"
                    name="allowedKm"
                    v-model="contractDetailModal.allowedKm"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>

                <span class="error" v-if="!contractDetailModal.allowedKm">{{
                  isAllowedKmError
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="15">
                <md-layout md-flex="100">
                  <label>Vehicle Modal</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="vehicleModal"
                    name="vehicleModal"
                    v-model="contractDetailModal.vehicleModal"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>

                <span class="error" v-if="!contractDetailModal.vehicleModal">{{
                  vehicleModalError
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Vehicle Type</label>
                <model-list-select
                  :isDisabled="permissionStatus"
                  :list="vehicleTypeMaster"
                  v-model="contractDetailModal.vehicleType"
                  option-value="vehicleTypeId"
                  option-text="vehicleType"
                  placeholder="Select Vehicle Type "
                ></model-list-select>

                <span class="error" v-if="!contractDetailModal.vehicleType">{{
                  vehicleTypeError
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <md-layout md-flex="100">
                  <label>Gross Weight</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="grossWeight"
                    name="grossWeight"
                    v-model="contractDetailModal.grossWeight"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>

                <span class="error" v-if="!contractDetailModal.grossWeight">{{
                  grossWeightError
                }}</span>
              </md-layout>
            </md-layout>

            <md-layout
              md-gutter
              class="gutr"
              v-if="contractDetailModal.contractType == 'freeKMType'"
            >
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>Additional charges over allowed Km</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="overcharges"
                    name="overcharges"
                    v-model="contractDetailModal.overcharges"
                    :disabled="permissionStatus"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!contractDetailModal.overcharges">{{
                  isOverChargesError
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="5"></md-layout>
            </md-layout>

            <md-layout md-gutter class="mrgtop-2per">
              <md-layout md-flex="5"></md-layout>
              <h4 style="margin: 0px; padding: 0px; color: green">Note:-</h4>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="5"></md-layout>
              <h4 style="margin: 0px; padding: 0px; color: green">
                1:Toll/Green Tax to be paid actual against receipt.
              </h4>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="5"></md-layout>
              <h4 style="margin: 0px; padding: 0px; color: green">
                2:Penalty/Challans/RTO will be borne by the Transporter.
              </h4>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="5"></md-layout>
              <h4 style="margin: 0px; padding: 0px; color: green">
                3:Cooling period will be 2 days in a month.
              </h4>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="5"></md-layout>
              <h4 style="margin: 0px; padding: 0px; color: green">
                4:Diesel, Driver & Maintenance will be borne by the
                Transporter..
              </h4>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="5"></md-layout>
              <h4 style="margin: 0px; padding: 0px; color: green">
                5:Documents will be Insurance, RC Copy, Permit, Fitness
                Certificate of the attached vehicle should be provided at the
                time of agreement.
              </h4>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="5"></md-layout>
              <h4 style="margin: 0px; padding: 0px; color: green">
                6: Goods & Service Tax(GST) as per applicable law.
              </h4>
            </md-layout>
          </div>
          <!-- /.box-body -->
        </div>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="addContract">Ok</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="PopDoc"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopSave"
      @close="onClose"
    ></md-dialog-alert>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop1"
      @close="onClose1"
      style="z-index: 99999999999999"
    ></md-dialog-alert>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseDelete"
      ref="addPopDeleteF"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import Vue from "vue";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import pickupLocation from "../locationMaster/pickupLocation.vue";
import Multiselect from "vue-multiselect";
export default {
  beforeMount() {
    this.clientDetails = this.$route.query.clientId;
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/client/addClient");
      this.getSegmentData();
      this.getClients();

      this.viewEditClient(this.$sessionsStorage.get("editClientId"));
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  props: {
    clientIdSales: String,
  },
  data() {
    return {
      selectDateFormat,
      showDocSection: [],
      contactPersonArry: [],
      clientList: [],
      userList: [],
      items: [],
      clientDetails: "",
      accountManagerList: [],
      CsList: [],
      documentaryList: [],
      lastSelectItem: {},
      docURL: URL_BASE_DOC,
      sectionRuleName: [
        {
          sectionRuleVal: "194A",
          sectionRuleText: "194A",
        },
        {
          sectionRuleVal: "194C",
          sectionRuleText: "194C",
        },
        {
          sectionRuleVal: "194H",
          sectionRuleText: "194H",
        },
        {
          sectionRuleVal: "194I",
          sectionRuleText: "194I",
        },
        {
          sectionRuleVal: "194J",
          sectionRuleText: "194J",
        },
      ],

      tdsStatusName: [
        {
          tdsStatusVal: "Individual_HUF",
          tdsStatusText: "Individual/HUF",
        },
        {
          tdsStatusVal: "Other_Than_Individual_HUF",
          tdsStatusText: "Other Than Individual HUF",
        },
        {
          tdsStatusVal: "Any_In_Case_Plant_Machinery",
          tdsStatusText: "Any In Case Plant Machinery",
        },
        {
          tdsStatusVal: "Any_In_Case_Land_Building",
          tdsStatusText: "Any In Case Land Building",
        },
      ],
      tdsPercentageName: [
        {
          tdsPercentageVal: "1%",
          tdsPercentageText: "1",
        },
        {
          tdsPercentageVal: "2%",
          tdsPercentageText: "2%",
        },
        {
          tdsPercentageVal: "5%",
          tdsPercentageText: "5%",
        },
        {
          tdsPercentageVal: "10%",
          tdsPercentageText: "10%",
        },
      ],
      clientTypeList: [
        {
          clientTypeVal: "Client",
          clientTypeText: "Client",
        },

        {
          clientTypeVal: "Overseas",
          clientTypeText: "Overseas",
        },
        {
          clientTypeVal: "Lead",
          clientTypeText: "Lead",
        },
        {
          clientTypeVal: "Transporter",
          clientTypeText: "Transporter",
        },
        {
          clientTypeVal: "Trader",
          clientTypeText: "Trader",
        },
        {
          clientTypeVal: "Freight_Forwarder",
          clientTypeText: "Freight Forwarder",
        },
        {
          clientTypeVal: "Consignee",
          clientTypeText: "Consignee",
        },
        // {
        //   clientTypeVal: "CHA",
        //   clientTypeText: "CHA"
        // }
      ],
      contractListName: [
        {
          contractTypeVal: "fuelType",
          contractTypeText: "Fuel Type",
        },
        {
          contractTypeVal: "freeKMType",
          contractTypeText: "Free KM Type",
        },
      ],
      docList: [
        {
          docV: "PAN_CARD",
          docT: "PAN CARD",
        },
        {
          docV: "ADDRESS_PROOF",
          docT: "ADDRESS PROOF",
        },
        {
          docV: "GST Certificate",
          docT: "GST Certificate",
        },
        {
          docV: "TAN",
          docT: "TAN",
        },
        {
          docV: "IEC",
          docT: "IEC",
        },
        {
          docV: "KYC",
          docT: "KYC",
        },
        {
          docV: "OTHERS",
          docT: "OTHERS",
        },
      ],

      companyPermitList: [
        {
          permitVal: "GSTRegistered",
          permitText: "GST Registered",
        },
        {
          permitVal: "GSTUnregistered",
          permitText: "GST Unregistered",
        },
        {
          permitVal: "SEZ",
          permitText: "SEZ",
        },
      ],
      companyTypeList: [
        {
          companyTypeVal: "Propreitorship",
          companyTypeText: "Propreitorship",
        },
        {
          companyTypeVal: "Partnership",
          companyTypeText: "Partnership",
        },
        {
          companyTypeVal: "privateLimited",
          companyTypeText: "Private Limited",
        },
        {
          companyTypeVal: "publicLimited",
          companyTypeText: "Public Limited",
        },
        {
          companyTypeVal: "HUF",
          companyTypeText: "HUF",
        },
        {
          companyTypeVal: "LLP",
          companyTypeText: "LLP",
        },
      ],

      permissionStatus:
        this.$sessionsStorage.get("PermissionStatus") != "" &&
        this.$sessionsStorage.get("PermissionStatus") &&
        this.$sessionsStorage.get("PermissionStatus") == "Read"
          ? true
          : false,
      factoryModal: {
        longitude: "",
        latitude: "",

        multiFactoryId: "",
        clientId: "",
        location: "",
        GSTIN1: "",
        factoryAddress1: "",
        factoryTitle: "",
      },
      errorEmailFormat: "",
      getLocationData: [],
      viewAllFactory: [],
      clientDetail: {
        stateCode: "",
        clientId: "",
        clientName: "",
        IEC: "",
        companyType: "",
        kycContact: "",
        hireContract: "",
        state: "",
        corporateAddress: "",
        remarkOtherDocument: "",
        segment: [],
        contractTerm: "",
        rateSigned: "",
        rateDiesel: "",
        paymentTerms: "",
        tolls: "",
        uploadKYC: "",

        factoryAddress2: "",
        GSTIN2: "",
        isContract: "",
        contractId: "",
        detentionPeriod: "",
        email: "",
        isKYC: "",
        isTds: "",
        sectionRule: "",
        tdsPercentage: "",
        tdsStatus: "",
        altMail: "",

        voterCard: "",
        panCard: "",
        aadharCard: "",
        nameKYC: "",
        emailKYC: "",
        phoneKYC: "",
        contactPersonDept: "",
        contactPersonDegination: "",
        customs: "",
        accounts: "",
        creditDays: "",
        GSTN: "",
        panNO: "",
        tanNO: "",
        accountManager: "",
        permitted: "",
        clientType: "",
      },
      contractDetailModal: {
        contractId: "",
        fromValidity: "",
        toValidity: "",
        contractType: "",
        // contractSeries: "",
        allowedKm: "",
        monthlyRent: "",
        overcharges: "",
        vehicleModal: "",
        vehicleType: "",
        grossWeight: "",
        noOfTrucks: "",
        milage: "",
        dieselRate: "",
      },
      mobileValid: "",
      vehicleTypeMaster: [],
      alert: {
        content:
          this.$sessionsStorage.get("editClientId") != "" &&
          this.$sessionsStorage.get("editClientId") != undefined
            ? " Data Updated Succesfully"
            : " Added Succesfully ",
        ok: "ok",
      },

      editVar: {
        Inputval:
          this.$sessionsStorage.get("editClientId") != "" &&
          this.$sessionsStorage.get("editClientId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editClientId") != "" &&
          this.$sessionsStorage.get("editClientId") != undefined
            ? "Update"
            : "New",
      },
      contractTable: [],
      employeeMaster: [],

      showSegmentArray: [],
      showDocumentArray: [],
      stateDetail: [],
      clientError: "",
      corporateAddressError: "",
      permittedError: "",
      clientTypeError: "",
      stateError: "",
      panNOError: "",
      segmentError: "",
      multiFactError: "",
      factoryAddress1Error: "",
      factoryTitleError: "",
      locationError: "",
      phoneKYCError: "",
      tanNOError: "",
      GSTNError: "",
      GSTNErrorValid: "",
      isContractError: "",
      isContractError1: "",
      hireContractError: "",
      isFromValidtyError: "",
      isToValidtyError: "",
      isContractError: "",
      isOverChargesError: "",
      hireContractError: "",
      isAllowedKmError: "",
      noOfTrucksError: "",
      vehicleModalError: "",
      vehicleTypeError: "",
      grossWeightError: "",
      milageError: "",
      dieselRateError: "",
      panCardError: "",
      aadharError: "",
      isMonthlyRentError: "",
      PANErrorValid: "",
      TANErrorValid: "",
      emailErrorValid: "",
      emailError: "",
      companyTypeError: "",
      // detentionPeriodError: "",
      validate: true,
      count: 0,
      isLoading: false,
    };
  },

  mounted() {
    if (
      this.$sessionsStorage.get("editClientId") == null &&
      this.$sessionsStorage.get("editClientId") == undefined
    ) {
      this.count = 2;
    }
    if (
      this.$sessionsStorage.get("editClientType") != "" &&
      this.$sessionsStorage.get("editClientType") != undefined
    ) {
      this.clientDetail.clientType =
        this.$sessionsStorage.get("editClientType");
    }
  },
  beforeDestroy() {
    // this.$sessionsStorage.set("editClientId", "");
    // this.$sessionsStorage.set("editClientType", "");
  },
  destroyed() {},
  components: {
    pickupLocation,
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    MultiSelect,
    Multiselect,
  },
  computed: {
    otherDocument() {
      return this.clientDetail.uploadKYC.split(",");
    },
    employeeMasterList() {
      return this.employeeMaster;
    },
    stateListData() {
      return this.stateDetail;
    },
    locationList() {
      return this.getLocationData;
    },
  },
  watch: {
    // clientIdSales: {
    //   handler: function (newVal, oldVal) {
    //     if (newVal != "") {
    //       this.viewEditClient(newVal);
    //       this.getTypeSize(newVal);
    //     }
    //   },

    //   deep: true,
    // },

    clientDetail: {
      handler(newVal, oldVal) {
        if (newVal.hasOwnProperty("GSTN", "panNO", "tanNO")) {
          this.clientDetail.GSTN = newVal.GSTN.toUpperCase();
          this.clientDetail.panNO = newVal.panNO.toUpperCase();
          this.clientDetail.tanNO = newVal.tanNO.toUpperCase();
        }

        if (this.clientDetail.state != "") {
          let arrayNew = this.stateDetail.filter((x) => {
            return x.stateId == this.clientDetail.state;
          });

          if (arrayNew.length > 0) {
            this.clientDetail.stateCode = arrayNew[0].gstCode;

            // this.cliearrayNew[0]
          }
        }
      },
      deep: true,
    },
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  methods: {
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.userList.push(tag);
      this.accountManagerList.push(tag);
    },

    onSelectionChange(event) {
      console.log("Events= > ", event);
    },
    onSelect(items, lastSelectItem) {
      this.accountManagerList = items;

      console.log();
    },

    SelectAM(items, lastSelectItem) {
      this.accountManagerList = items;

      console.log();
    },

    SelectCS(items, lastSelectItem) {
      this.CsList = items;

      console.log();
    },

    selectDoc(items, lastSelectItem) {
      this.documentaryList = items;

      console.log();
    },
    // deselect option
    reset() {
      this.items = []; // reset
    },
    // select option from parent component
    selectFromParentComponent() {
      this.items = _.unionWith(this.items, [this.options[0]], _.isEqual);
      console.log("Item =>", this.items);
    },
    previewPrivateDocs(item) {
      let paylod = {
        privateDocName: item,
        id: "Client_Kyc",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/viewPrivateDoc.php`,
        data: JSON.stringify(paylod),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.status == "success") {
              window.open(`${this.docURL}/CLIENTKYCDOC/` + item);
              // window.open(`${this.docURL}/templibblock/` + item);
            } else {
              this.alert.content = "Document Not Found";
              this.$refs["PopDoc"].open();
            }
          }
        })
        .catch((error) => {});

      // :href="
      //                         `${docURL}/CLIENTKYCDOC/` +
      //                         item.uploadedkycDoc
      //                       "
    },
    removeDoc(index) {
      this.showDocSection.splice(index, 1);
    },
    AddMoreDocs() {
      let obj = {
        kycDocName: "",
        uploadedkycDoc: "",
      };
      this.showDocSection.push(obj);
    },

    removeCp(index) {
      this.contactPersonArry.splice(index, 1);
    },
    AddMoreContactP() {
      let obj = {
        name: "",
        email: "",
        phone: "",
        dept: "",
        deg: "",
      };
      this.contactPersonArry.push(obj);
    },

    showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    fetchLatLog() {
      let options = {
        method: "GET",
        url:
          // `https://www.mapquestapi.com/geocoding/v1/address?key=OTLGZmcN6qXiHnH4qSU4lXTYWLPEoINP&location=` +
          `https://www.mapquestapi.com/geocoding/v1/address?key=AiBjJ4PC52j31H0BO1xlTTXDHIAZwDD0&location=` +
          this.factoryModal.factoryAddress1,
      };

      axios(options)
        .then((result) => {
          console.log(result.data.results[0].locations[0].displayLatLng);
          this.factoryModal.latitude =
            result.data.results[0].locations[0].displayLatLng.lat;
          this.factoryModal.longitude =
            result.data.results[0].locations[0].displayLatLng.lng;
        })
        .catch((error) => {});
    },
    deleteData(id) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPopDeleteF"].open();
    },
    onCloseDelete(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "client_multi_factory",
          tableId: "multiFactoryId",
          tableIsActive: "isMultifactoryActive",
          tableVal: this.deleteId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deleteData.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.JqueryFun();
              this.getTypeSize(this.$sessionsStorage.get("editClientId"));
              // console.log(data);
            }
          })
          .catch((error) => {});
      }
    },
    isEmailValid() {
      let emailreg =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

      if (emailreg.test(this.clientDetail.email)) {
        this.errorEmailFormat = "";
      } else {
        this.errorEmailFormat = "Enter Valid Email";
      }
    },
    EditFactory(item) {
      this.$refs["my-modal"].show();
      Object.keys(this.factoryModal).map((x) => {
        this.factoryModal[x] = item[x] || "";
      });
    },
    closeModal() {
      this.$refs["dialog2"].close();
    },
    closeModalLocation() {
      this.$refs["dialogLocation"].close();
      this.getTypeSize(this.$sessionsStorage.get("editClientId"));
    },
    viewContract(contractId) {
      this.$sessionsStorage.set("editContractId", contractId);
      this.$router.push({
        path: "/viewHireContract",
      });
    },
    employeeMasterFilter(list, query) {
      return this.employeeMaster.filter((x) => {
        return x.employeeName.toLowerCase().includes(query.toLowerCase());
      });
    },
    onFileChangeKyc(index, DOCNAME) {
      this.isLoading = true;
      let files = event.target.files || event.dataTransfer.files;
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
        formData.append(
          "moduleId",
          this.$sessionsStorage.get("editClientId") + "-" + index
        );
        formData.append(
          "staticFileName",
          this.clientDetail.clientName + "_" + DOCNAME
        );
        formData.append("upload_dir_folderName", "CLIENTKYCDOC");
      }

      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAll.php`, formData, config)
        .then((result) => {
          this.showDocSection[index].uploadedkycDoc = result.data;

          this.isLoading = false;
        })
        .catch((err) => {
          throw err;
        });
    },

    getTypeSize(idCl) {
      this.isLoading = true;
      let type_Size = {
        truckTS: "truckTS",

        clientId: idCl,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/fetchTypeSizeTruck.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            if (data.truckTypeDetails.length > 0) {
              this.vehicleTypeMaster = data.truckTypeDetails;
            } else {
              this.vehicleTypeMaster = [];
            }
            if (data.factoryLocationData.length > 0) {
              this.getLocationData = data.factoryLocationData;
            } else {
              this.getLocationData = [];
            }
            if (data.multiFactoryData.length > 0) {
              this.viewAllFactory = data.multiFactoryData;
            } else {
              this.viewAllFactory = [];
            }

            this.isLoading = false;

            if (
              this.$sessionsStorage.get("editClientId") != "" &&
              this.$sessionsStorage.get("editClientId") != undefined
            ) {
            } else {
              this.clientDetail.accountManager =
                data.UserDetail1[0].employeeName;
            }
          }
        })
        .catch((error) => {});
    },

    onClose(type) {
      this.$router.push({
        path: "/client/viewClient",
      });
    },
    previousClientView() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/client/viewClient"
      //   // params:{
      //   //   "userId":res.data.Id,
      //   // }
      // });
    },
    hireModel() {
      var currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);
      let contractFilter = contractTable.filter((y) => {
        let validDate = new Date(y.toValidity);

        return (
          y.clientId == this.clientListData.clientId && validDate > currentDate
        );
      });

      if (contractFilter.length > 0) {
        this.$sessionsStorage.set(
          "setContractId",
          contractFilter[0].contractId
        );
        this.$sessionsStorage.set("clientId", this.clientListData.clientId);
        this.$router.push({
          path: "/listView/hireModel",
        });
      } else {
        this.alert.content =
          "Please add a new contract . Your Contract validity is out of date.";
        this.$refs["addPop1"].open();
      }
    },

    onClose1(type) {
      let payload = {
        contractId: this.clientDetail.contractId,
      };
      if (this.clientDetail.clientId != "") {
        payload["clientId"] = this.clientDetail.clientId;
      } else {
        payload["clientId"] = "";
      }

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TPTContract/viewContractTable.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.contractArray.length > 0) {
              this.contractTable = data.contractArray;
            }

            this.JqueryFun();
            this.$refs["addPop1"].close();
          }
        })
        .catch((error) => {});
    },
    JqueryFun() {
      $(function () {
        return $("#contracthireModel").DataTable();
        return $("#factoryDetails").DataTable();
      });
    },

    viewEditClient(id) {
      this.isLoading = true;
      let edit_Client = {
        edit: "edit",
        clientId: id,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewEditClient.php`,
        data: JSON.stringify(edit_Client),

        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          let array = [];
          let array1 = [];

          if (status == 200 && data) {
            if (data.editClient.length > 0) {
              if (
                data.editClient[0].uploadedkycDoc != null &&
                data.editClient[0].uploadedkycDoc != ""
              ) {
                let uploadedDoc = data.editClient[0].uploadedkycDoc.split(",");
                let uploadedDocName = data.editClient[0].kycDocName.split(",");
                for (let i = 0; i < uploadedDoc.length; i++) {
                  let obj = {
                    kycDocName: uploadedDocName[i],
                    uploadedkycDoc: uploadedDoc[i],
                  };
                  this.showDocSection.push(obj);
                }
              }

              if (
                data.editClient[0].nameKYC != null &&
                data.editClient[0].nameKYC != ""
              ) {
                let nameKYCArr = data.editClient[0].nameKYC.split(",");
                let phoneKYCArr = data.editClient[0].kycContact.split(",");
                let emailKYCArr = data.editClient[0].emailKYC.split(",");
                let contactPersonDeptArr =
                  data.editClient[0].contactPersonDept.split(",");
                let contactPersonDeginationArr =
                  data.editClient[0].contactPersonDegination.split(",");
                for (let j = 0; j < nameKYCArr.length; j++) {
                  let obj = {
                    name: nameKYCArr[j],
                    email: emailKYCArr[j],
                    phone: phoneKYCArr[j],
                    dept: contactPersonDeptArr[j],
                    deg: contactPersonDeginationArr[j],
                  };
                  this.contactPersonArry.push(obj);
                }
              }

              Object.keys(data.editClient[0]).map((x) => {
                this.clientDetail[x] = data.editClient[0][x] || "";

                if (
                  x == "segment" &&
                  data.editClient[0][x] != null &&
                  data.editClient[0][x] != undefined
                ) {
                  console.log();
                  array = data.editClient[0][x].split(",");
                }
              });
              this.clientDetail["segment"] = [];

              this.showSegmentArray.map((x, index) => {
                let i = array.indexOf(x.value);

                i >= 0
                  ? (this.clientDetail.segment[index] = true)
                  : (this.clientDetail.segment[index] = false);
              });
            }

            if (data.multiFactoryData.length > 0) {
              this.viewAllFactory = data.multiFactoryData;
            } else {
              this.viewAllFactory = [];
            }

            this.stateDetail = data.statelist;
            this.isLoading = false;
            // this.clientDetail.contractId += ",";
            // this.showContract(this.clientDetail.contractId);
          }
        })
        .catch((error) => {});
      //sdsd
    },
    mobileValidation() {
      var mobileFormat = new RegExp("^[0-9]{10}$");

      if (mobileFormat.test(this.clientDetail.phoneKYC)) {
        this.mobileValid = "";
      } else {
        this.mobileValid = "Please Enter Valid Mobile No.";
      }
    },
    showContract(contractid) {
      console.log(contractid, "tyghjtryuhjj");
      let payload = {
        contractId: contractid,
        clientId: this.$sessionsStorage.get("editClientId"),
      };
      console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TPTContract/viewContractTable.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data, "uyiu");
            if (data.contractArray.length > 0) {
              this.contractTable = data.contractArray;
            }

            this.JqueryFun();
            this.$refs["addPop1"].close();
          }
        })
        .catch((error) => {});
    },

    getClients() {
      // console.log(contractid, "tyghjtryuhjj");

      // alert(this.$route.query.clientId);
      let payload = {
        user: "employee",
        client: "client",
        clientId: this.$route.query.clientId,
      };
      console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/getClientDeptDetails_VP.php`,
        // url: `${URL_BASE}/Api_Master/getClientDeptDetails.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data, "uyiu");
            if (data.userDataList.length > 0) {
              this.userList = data.userDataList;
            }
            if (data.clientDataList.length > 0) {
              this.clientList = data.clientDataList;
              this.clientDetails = data.clientDataList[0].clientId;
              this.accountManagerList = JSON.parse(
                data.clientDataList[0].accountManager
              );
              this.CsList = JSON.parse(data.clientDataList[0].cs);
              this.documentaryList = JSON.parse(
                data.clientDataList[0].documentary
              );
            }

            console.log("userlist => ", this.userList);
            console.log("ClientList => ", this.clientList);

            // this.JqueryFun();
            // this.$refs["addPop1"].close();
          }
        })
        .catch((error) => {});
    },

    GSTNErrorValid1() {
      var gstinformat = new RegExp(
        "^[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$"
      );

      if (gstinformat.test(this.clientDetail.GSTN)) {
        this.GSTNErrorValid = "";
      } else {
        this.GSTNErrorValid = "Please Enter Valid GSTN";
      }
    },
    PANErrorValid1() {
      var paninformat = new RegExp("^[A-Z]{5}[0-9]{4}[A-Z]{1}$");

      if (paninformat.test(this.clientDetail.panNO)) {
        this.PANErrorValid = "";
      } else {
        this.PANErrorValid = "Please Enter Valid PAN No.";
      }
    },
    TANErrorValid1() {
      var taninformat = new RegExp("^[A-Z]{4}[0-9]{5}[A-Z]{1}$");

      if (taninformat.test(this.clientDetail.tanNO)) {
        this.TANErrorValid = "";
      } else {
        this.TANErrorValid = "Please Enter Valid TAN No.";
      }
    },
    validateContract() {
      let validate_new = true;
      if (this.contractDetailModal.fromValidity == "") {
        $("#fromValidity").focus();
        this.isFromValidtyError = "Select Validity Date";
        validate_new = false;
      }

      if (this.contractDetailModal.toValidity == "") {
        $("#toValidity").focus();
        this.isToValidtyError = "Select Validity Date";
        validate_new = false;
      }
      if (this.contractDetailModal.contractType == "") {
        $("#contractType").focus();
        this.isContractError = "Select Contract Type";
        validate_new = false;
      }

      if (this.contractDetailModal.monthlyRent == "") {
        $("#monthlyRent").focus();
        this.isMonthlyRentError = "Enter Monthly Month";
        validate_new = false;
      }

      if (
        this.contractDetailModal.contractType == "freeKMType" &&
        this.contractDetailModal.allowedKm == ""
      ) {
        $("#allowedKm").focus();
        this.isAllowedKmError = "Enter Allowed Kilometer";
        validate_new = false;
      }
      if (
        this.contractDetailModal.contractType == "fuelType" &&
        this.contractDetailModal.milage == ""
      ) {
        $("#milage").focus();
        this.milageError = "Enter your milage";
        validate_new = false;
      }
      if (
        this.contractDetailModal.contractType == "fuelType" &&
        this.contractDetailModal.dieselRate == ""
      ) {
        $("#dieselRate").focus();
        this.dieselRateError = "Enter your  diesel rate";
        validate_new = false;
      }

      if (this.contractDetailModal.noOfTrucks == "") {
        $("#noOfTrucks").focus();
        this.noOfTrucksError = "Enter No. of Trucks";
        validate_new = false;
      }
      if (
        this.contractDetailModal.contractType == "freeKMType" &&
        this.contractDetailModal.vehicleType == ""
      ) {
        $("#vehicleType").focus();
        this.vehicleTypeError = "Select Vehicle Type";
        validate_new = false;
      }
      if (
        this.contractDetailModal.contractType == "freeKMType" &&
        this.contractDetailModal.vehicleModal == ""
      ) {
        $("#vehicleModal").focus();
        this.vehicleModalError = "Select vehicle Modal";
        validate_new = false;
      }
      if (
        this.contractDetailModal.contractType == "freeKMType" &&
        this.contractDetailModal.grossWeight == ""
      ) {
        $("#grossWeight").focus();
        this.grossWeightError = "Enter Gross Weight";
        validate_new = false;
      }

      if (
        this.contractDetailModal.contractType == "freeKMType" &&
        this.contractDetailModal.overcharges == ""
      ) {
        $("#overcharges").focus();
        this.isOverChargesError = "Enter OverChages";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    validateClientForm(id) {
      let validate_new = true;

      var gstinformat = new RegExp(
        "^[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$"
      );

      var paninformat = new RegExp("^[A-Z]{5}[0-9]{4}[A-Z]{1}$");
      var taninformat = new RegExp("^[A-Z]{4}[0-9]{5}[A-Z]{1}$");

      if (this.clientDetail.clientName == "") {
        $("#clientName").focus();
        this.clientError = "Please Enter your name";
        validate_new = false;
      }

      if (this.clientDetail.clientType == "") {
        $("#clientType").focus();
        this.clientTypeError = "Please Select your type";
        validate_new = false;
      }

      if (this.clientDetail.companyType == "") {
        $("#companyType").focus();
        this.companyTypeError = "Please select company";
        validate_new = false;
      }
      if (this.clientDetail.permitted != "GSTUnregistered") {
        if (gstinformat.test(this.clientDetail.GSTN)) {
          this.GSTNErrorValid = "";
        } else {
          validate_new = false;
          $("#GSTN").focus();

          this.GSTNErrorValid = "Please Enter Valid GSTN";
        }

        if (this.clientDetail.GSTN == "") {
          $("#GSTN").focus();
          this.GSTNError = "Please Enter GSTN";
          validate_new = false;
        }
      }
      if (paninformat.test(this.clientDetail.panNO)) {
        this.PANErrorValid = "";
      } else {
        validate_new = false;
        $("#panNO").focus();

        this.PANErrorValid = "Please Enter Valid PAN No.";
      }

      if (this.clientDetail.panNO == "") {
        $("#panNO").focus();
        this.panNOError = "Please Enter your pan no.";
        validate_new = false;
      }

      // if (
      //   this.clientDetail.isContract == "Yes" &&
      //   this.clientDetail.hireContract == ""
      // ) {
      //   $("#isContract2").focus();
      //   this.hireContractError = "Select a particular Contract";
      //   validate_new = false;
      // }

      // if (
      //   this.clientDetail.contractId == "" &&
      //   this.clientDetail.isContract == "Yes" &&
      //   this.clientDetail.hireContract == "hireContract"
      // ) {
      //   $("#isContract2").focus();
      //   this.isContractError1 = "Add atleast one contract";
      //   validate_new = false;
      // }

      if (this.clientDetail.state == "") {
        $("#state").focus();
        this.stateError = "Please Enter your state name";
        validate_new = false;
      }

      if (taninformat.test(this.clientDetail.tanNO)) {
        this.TANErrorValid = "";
      } else {
        validate_new = false;
        $("#tanNO").focus();

        this.TANErrorValid = "Please Enter Valid TAN No.";
      }
      if (this.clientDetail.tanNO == "") {
        $("#tanNO").focus();
        this.tanNOError = "Please Enter your tan No.";
        validate_new = false;
      }

      if (this.clientDetail.corporateAddress == "") {
        $("#corporateAddress").focus();
        this.corporateAddressError = "Please Enter your address";
        validate_new = false;
      }

      if (this.clientDetail.email == "") {
        $("#email").focus();
        this.emailError = "Please Enter Email address";
        validate_new = false;
      }

      if (this.clientDetail.phoneKYC == "") {
        $("#phoneKYC").focus();
        this.phoneKYCError = "Enter your number";
        validate_new = false;
      }

      // if (this.clientDetail.isKYC == "Yes" && this.clientDetail.panCard == "") {
      //   this.panCardError = "Upload your pancard document";
      //   validate_new = false;
      // }

      // if (
      //   this.clientDetail.isKYC == "Yes" &&
      //   this.clientDetail.aadharCard == ""
      // ) {
      //   this.aadharError = "Upload Your GST document";
      //   validate_new = false;
      // }

      if (id == "") {
        if (this.factoryModal.factoryAddress1 == "") {
          $("#factoryAddress1").focus();

          this.factoryAddress1Error = "Enter Factory Address";
          validate_new = false;
        }
        // if (this.factoryModal.location == "") {
        //   $("#location").focus();
        //   this.locationError = "Enter Factory Location";
        //   validate_new = false;
        // }
        if (this.factoryModal.factoryTitle == "") {
          $("#factoryTitle").focus();
          this.factoryTitleError = "Enter Factory Title";
          validate_new = false;
        }
      }
      // if (id != "") {
      //   if (this.viewAllFactory.length <= 0) {
      //     this.multiFactError = "Enter atleast one Factory Details";
      //     validate_new = false;
      //   } else {
      //     this.multiFactError = "";
      //   }
      //   // if (this.clientDetail.detentionPeriod == "") {
      //   //   $("#detentionPeriod").focus();
      //   //   this.detentionPeriodError = "Enter your detention";
      //   //   validate_new = false;
      //   // }
      //   if (this.clientDetail.permitted == "") {
      //     $("#permitted1").focus();
      //     this.permittedError = "Please Select your Permit";
      //     validate_new = false;
      //   }
      //   if (this.clientDetail.isContract == "") {
      //     $("#isContract2").focus();
      //     this.isContractError = "Please select your contract";
      //     validate_new = false;
      //   }
      // }
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addClient(id) {
      this.clientDetail["kycDocSection"] = this.showDocSection;
      this.clientDetail["contactPersonArry"] = this.contactPersonArry;
      this.validateClientForm(id);

      let emailreg =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

      if (emailreg.test(this.clientDetail.email)) {
        this.errorEmailFormat = "";
      } else {
        this.errorEmailFormat = "Enter Valid Email";
        window.scroll(0, 20);
        return false;
      }

      if (this.validate != false) {
        this.isLoading = true;
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let newVal = [];
        if (id != "") {
          this.showSegmentArray.map((x, index) => {
            if (this.clientDetail.segment[index] == true) {
              newVal.push(x.value);
            }
          });

          this.clientDetail.segment = newVal;
        }
        let new_data = {
          clientDetail: this.clientDetail,
          factoryModal: this.factoryModal,
        };
        console.log(new_data);
        if (id == "") {
          new_data["onlyExecMain"] = "";
        } else {
          new_data["onlyExecMain"] = "csfds";
        }
        // console.log(new_data);
        // return false;

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addClient.php`,
          data: JSON.stringify(new_data),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            console.log(result.data);
            if (this.$sessionsStorage.get("editClientId") != "") {
              this.$sessionsStorage.set("editClientId", result.data.clientId);
              this.clientDetail.clientId = result.data.clientId;
            }
            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");
            this.getTypeSize(this.$sessionsStorage.get("editClientId"));
            if (id != "") {
              this.alert.content = "Action Successful";
              this.$refs["addPopSave"].open();
            }
          })
          .catch((error) => {});
      }
    },

    addClientDept() {
      let new_data = {
        clientId: this.clientDetails,
        accountManager: this.accountManagerList,
        cs: this.CsList,
        documentary: this.documentaryList,
      };

      console.log("New Data => ", new_data);

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/addClientDept_VP.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          console.log(result.data);
          if (this.$sessionsStorage.get("editClientId") != "") {
            this.$sessionsStorage.set("editClientId", result.data.clientId);
            this.clientDetail.clientId = result.data.clientId;
          }
          $("#addButtonLoader").css("display", "block");
          $("#loader").css("display", "none");
          this.getTypeSize(this.$sessionsStorage.get("editClientId"));
          if (id != "") {
            this.alert.content = "Action Successful";
            this.$refs["addPopSave"].open();
          }
        })
        .catch((error) => {});
    },
    openLocationDialog() {
      this.$refs["dialogLocation"].open();
    },
    openContractDialog() {
      this.$refs["dialog2"].open();
    },
    fetchState() {
      let vehicle_drive = {
        state: "state",
      };
      if (this.count >= 2) {
        vehicle_drive["stateId"] = this.clientDetail.state;
      } else {
        vehicle_drive["stateId"] = "";
      }

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/fetchStateToClient.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            this.stateDetail = data.statelist;

            if (data.gstCode != "") {
              this.clientDetail.GSTN = data.gstCode;
            }
            this.count++;
          }
        })
        .catch((error) => {});
    },
    addContract() {
      this.validateContract();
      if (this.validate != false) {
        if (this.clientDetail.clientId != "") {
          this.contractDetailModal["clientId"] = this.clientDetail.clientId;
        } else {
          this.contractDetailModal["clientId"] = "";
        }
        this.$refs["dialog2"].close();
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_TPTContract/addContractDetail.php`,
          data: JSON.stringify(this.contractDetailModal),

          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.clientDetail.contractId += data.Id + ",";

              this.$refs["addPop1"].open();
            }
          })
          .catch((error) => {});
      }
    },
    validateUser() {},
    getSegmentData() {
      this.showSegmentArray = [
        {
          value: "OceanImport",
          show: "Ocean Import",
          flex: "15",
        },
        {
          value: "OceanExport",
          show: "Ocean Export",
          flex: "15",
        },
        {
          value: "AirImport",
          show: "Air Import",
          flex: "15",
        },

        {
          value: "AirExport",
          show: "Air Export",
          flex: "15",
        },
        {
          value: "Trucking",
          show: "Trucking",
          flex: "15",
        },
        {
          value: "CustomClearance",
          show: "Custom Clearance",
          flex: "20",
        },
      ];

      this.showDocumentArray = [
        {
          value: "panCard",
          show: "Pan Card",
          flex: "15",
          url: `${this.docURL}/Client/Pancard/`,
        },
        {
          value: "aadharCard",
          show: "GST Certificate",
          flex: "15",
          url: `${this.docURL}/Client/Aadhar/`,
        },
        {
          value: "voterCard",
          show: "Address Proof",
          flex: "15",
          url: `${this.docURL}/Client/VoterCard/`,
        },
        {
          value: "uploadKYC",
          show: "Other Document",
          flex: "15",
          url: `${this.docURL}/Client/Other/`,
        },
      ];
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 2%;
}
.mrgtop-3per {
  margin-top: 4%;
}
.mrgtop-5px {
  margin-top: 5px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 5px !important;
}

h3 {
  margin: 0px !important;
}

.md-button-color {
  background-color: #607d8d !important;
}
.error {
  color: red;
}
.md-dialog-container.HereDialog.md-theme-default {
  z-index: 99;
}

.md-dialog-container.HereDialog.md-theme-default .md-dialog {
  width: 100%;
  height: 100%;
}
.back {
  margin-top: 8px;
  height: 1px;
}
.hr-s {
  margin-top: 10px;
  margin-bottom: 10px;
  border-top: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// addClientDept.vue?f84b321e